<template>
  <div class="import-participantes">
    <!-- <app-search-bar/> -->
    
    <b-row>
      <b-col cols="12" xl="12">  
        <b-card header="Datos del Evento">
          <b-form>
            <b-form-group
              label="Cliente"
              label-for="cliente"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="cliente"
                :value="clienteNombre"
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Evento"
              label-for="evento"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="evento"
                :value="eventoNombre"
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>
          </b-form>
        </b-card>
      </b-col>
    </b-row>

    <!-- <b-row>
      <b-col cols="12" xl="12">
        <app-filtro
          :nombre="nombre"
          :documentoNumero="documentoNumero"
          :documentoNumeroHabilitado="documentoNumeroHabilitado"
          :email="email"
          :emailHabilitado="emailHabilitado"
          :numeroCelular="numeroCelular"
          :numeroCelularHabilitado="numeroCelularHabilitado"
          :negocio="negocio"
          :cuitNegocio="cuitNegocio"
          :negocioHabilitado="negocioHabilitado"
          :codigoPromocion="codigoPromocion"
          :codigoPromocionHabilitado="codigoPromocionHabilitado"
          :numeroCliente="numeroCliente"
          :numeroClienteHabilitado="numeroClienteHabilitado"
          @filtrar="filtrar">
        </app-filtro>  
      </b-col>      
    </b-row> -->

    <b-row>
      <b-col cols="12" xl="12">  
        <transition name="slide">
          <b-card header="Listado de Participantes">
            <b-table hover
                responsive="sm" 
                class="registro"
                :busy="tableBusy"
                :items="participantes" 
                :fields="participantesFields" 
                :current-page="paginaActual"
                :per-page="registrosPorPagina"
                @row-clicked="consultar">
              <div slot="table-busy" class="text-center">
                <b-spinner class="table-spinner" label="Spinning" />
              </div>
              <template v-slot:cell(fechaNacimiento)="data">
                {{ data.item.fechaNacimiento | fecha }}
              </template>
              <!-- <template v-slot:cell(opciones)="data">
                <b-dropdown 
                    v-if="agregarHabilitado"
                    variant="link" toggle-class="text-decoration-none" no-caret>
                  <template slot="button-content">
                    <i class="fa fa-ellipsis-v"></i>
                  </template>
                  <b-dropdown-item 
                      v-if="agregarHabilitado & editarHabilitado"
                      @click.stop="editarItem(data.item)">
                    <i class="fa fa-edit"></i>Editar Datos del Participante</b-dropdown-item>
                  <b-dropdown-item 
                      v-if="agregarHabilitado & borrarHabilitado"
                      @click.stop="borrarItem(data.item)">
                    <i class="fa fa-remove"></i>Borrar Participante</b-dropdown-item>
                </b-dropdown>
              </template> -->
            </b-table>
            <nav>
              <b-pagination size="sm" 
                :total-rows="totalRegistros" 
                :per-page="registrosPorPagina" 
                v-model="paginaActual" prev-text="Prev." next-text="Prox."/>
            </nav>
          </b-card>
        </transition>
      </b-col>
    </b-row>

    <div class="fixed-btn">
      <div class="data-goback-btn" @click.prevent="goBack">
          <i class="fa fa-undo fa-2x" aria-hidden="true"></i>
      </div>
    </div>

    <!-- <div class="fixed-btn">
      <div class="list-dropdown-btn">
        <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
          <template slot="button-content">
            <i class="fa fa-ellipsis-v fa-2x" aria-hidden="true"></i>
          </template>
          
          <b-dropdown-item @click.stop="goBack">
            <i class="fa fa-undo"></i>Volver</b-dropdown-item>
        </b-dropdown>
      </div>
    </div> -->

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>

    <app-confirm
      :confirmModalVisible="confirmModalVisible"
      :confirmMsj="confirmMsj"
      :confirmOkTitle="confirmOkTitle"
      :confirmCancelTitle="confirmCancelTitle"
      @confirmOk="confirmOk"
      @confirmCancel="confirmCancel">
    </app-confirm>
  </div>
</template>

<script>
// import Filtro from './listFiltro.vue';
import Mensaje from  '../shared/msjModal.vue';
import Confirm from  '../shared/confirmModal.vue';
import { msjModal, confirmModal } from '../../mixins/modalDialogs';
import moment from 'moment';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'importParticipantes/getField',
  mutationType: 'importParticipantes/updateField',
});

export default {
  name: 'ImportParticipantes',
  components: {
    // appFiltro: Filtro,
    appMensaje: Mensaje,
    appConfirm: Confirm,
  },
  mixins: [ 
    msjModal, 
    confirmModal,
  ],
  data: () => {
    return {
      participantesFields: [
        { 
          key: 'nombreCompleto',
          label: 'Nombre'
        },
        { 
          key: 'documentoNumero',
          label: 'Nro.Documento'
        },
        {
          key: 'opciones',
          label: '',
          class: 'text-center'
        },
      ],

      tableBusy: false,
      labelCols: 1,
    }
  },
  computed: {
    ...mapFields([
      'evento',
      'clienteNombre',
      'eventoNombre',
      'camposAdicionales',
      'participantesColumnas',
      'importaGanadores',

      'participantes',
      'paginaActual',
      'registrosPorPagina',
      'totalRegistros',
      'totalPaginas',
      'nombre',
      'documentoNumero',
      'email',
      'numeroCelular',
      'negocio',
      'cuitNegocio',
      'numeroCliente',
      'codigoPromocion',

      // 'nombreHabilitado',
      // 'documentoNumeroHabilitado',
      // 'emailHabilitado',
      // 'numeroCelularHabilitado',
      // 'negocioHabilitado',
      // 'cuitNegocioHabilitado',
      // 'numeroClienteHabilitado',
      // 'codigoPromocionHabilitado'
    ]),
    // numeroClienteHabilitado() {
    //   let clienteId = parseInt(this.$store.getters['user/admin']);
    //   if (clienteId == 1) {
    //     return true;
    //   }

    //   return false
    // },
  },
  created() {
    this.eventoId = 0;
    this.importParticipantesId = 0;

    if (this.$route.params){
      if (this.$route.params.eventoId){
        this.eventoId = this.$route.params.eventoId;
      }
      if (this.$route.params.id){
        this.importParticipantesId = this.$route.params.id;
      }
    }
  
    let params = {
      eventoId: this.eventoId,
      importParticipantesId: this.importParticipantesId
    };

    this.showSpinner();
    this.$store.dispatch('importParticipantes/inicializar', params)
      .then(() => this.formatoGrilla())
      .catch(error => this.showErrorMsj(error))
      .finally(() => this.hideSpinner())
  },  
  methods: {
    formatoGrilla() {
      this.participantesFields = [];

      /* Importacion de ganadores (si tiene posición, la mostramos en primer lugar) */
      if ((/true/i).test(this.importaGanadores)) {
        this.participantesFields.push({ 
              key: 'posicionSorteo',
              label: 'Posición',
              class: 'text-right'
            });
      }

      let formatoPropio = false;

      /* ParticipantesColumnas */
      if (this.participantesColumnas) {
        if (this.participantesColumnas.length != 0) {
          formatoPropio = true;

          this.participantesColumnas.forEach(participanteColumna => {
            this.participantesFields.push({ 
              key: participanteColumna.columna,
              label: participanteColumna.titulo
            });
          });
        }
      }
      /* CamposAdicionales */
      if (this.camposAdicionales) {
        if (this.camposAdicionales.length != 0) {
          formatoPropio = true;

          this.camposAdicionales.forEach(campoAdicional => {
            if ((/true/i).test(campoAdicional.incluirListado)) {
              this.participantesFields.push({ 
                key: `cp${campoAdicional.id}`,
                label: campoAdicional.campo
              });
            }
          });
        }
      }

      if (!formatoPropio) {
        if ((/true/i).test(this.solicitaCodigoPromocion)) {
          this.participantesFields.push({
              key: 'codigoPromocion',
              label: 'Cod.Promoción'
            });
        }

        if ((/true/i).test(this.participacionNegocios)) {
          this.participantesFields.push({
              key: 'negocio'
            });
          this.participantesFields.push({
              key: 'negocioCuit',
              label: 'CUIT'
            });
        } else {
          this.participantesFields.push({ 
            key: 'nombreCompleto',
            label: 'Nombre'
          });

          this.participantesFields.push({
            key: 'documentoNumero',
            label: 'Nro.Documento'
          });            
        }
      }

    },
    // filtrar(filtro) {
    //   this.nombre = filtro.nombre.trim();
    //   this.documentoNumero = filtro.documentoNumero.trim();
    //   this.email = filtro.email;
    //   this.numeroCelular = filtro.numeroCelular;
    //   this.negocio = filtro.negocio;
    //   this.cuitNegocio = filtro.cuitNegocio;
    //   this.codigoPromocion = filtro.codigoPromocion.trim();
    //   this.numeroCliente = filtro.numeroCliente.trim();
    //   this.paginaActual = 1;
      
    //   this.getItems();
    // },
    consultar (item) {
      this.$router.push({ name: 'ImportParticipante', 
                          params: { 
                            eventoId: this.eventoId,
                            importParticipantesId: this.importParticipantesId,
                            id: item.id
                          }});
    },
    goBack() {
      // this.$router.push({ name: 'Eventos' });
      this.$router.go(-1);
    },
  },
  // watch: {
  //   'paginaActual' : function(newVal, oldVal) {
  //     if ( newVal != 0 && oldVal != 0) {
  //       this.getItems();
  //     }
  //   },
  // }    
}
</script>

<style>
</style>
